module.exports = __webpack_public_path__ + "static/img/service_QQ.cf073e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightSide/service_QQ.png
// module id = uYvM
// module chunks = 4